require('./responsive-image.scss');

import checkBackground from '../../core/helpers/responsive-background';
import {
      MEDIAQUERY_XSMALL,
      MEDIAQUERY_SMALL,
      MEDIAQUERY_MEDIUM,
      MEDIAQUERY_LARGE,
      MEDIAQUERY_XLARGE,
    } from '../../core/constants';
riot.tag2('responsive-image', '<div class="responsiveimage-container"> <img if="{imageUrl}" riot-src="{imageUrl}" alt="" class="responsiveImage-image"> </div>', '', '', function(opts) {

    const self = this;

    const breakpoints = [
      {
        matchMedia: window.matchMedia(MEDIAQUERY_XSMALL),
        parameter: 'LogoXSmall',
      },
      {
        matchMedia: window.matchMedia(MEDIAQUERY_SMALL),
        parameter: 'LogoSmall',
      },
      {
        matchMedia: window.matchMedia(MEDIAQUERY_MEDIUM),
        parameter: 'LogoMedium',
      },
      {
        matchMedia: window.matchMedia(MEDIAQUERY_LARGE),
        parameter: 'LogoLarge',
      },
      {
        matchMedia: window.matchMedia(MEDIAQUERY_XLARGE),
        parameter: 'LogoXLarge',
      },
    ];

    checkBackground({
      callback: (imageUrl) => {
        self.imageUrl = imageUrl;
        self.update();
      },
      startDate: self.getLabel('promotional.StartDate'),
      endDate: self.getLabel('promotional.EndDate'),
      data: self.getLabel('promotional'),
      breakpoints,
    });
});
